export default __webpack_public_path__ + "static/media/rafiki.03a2b3cf.png";